import { Box, Group, Text } from "@mantine/core"
import { ReactNode } from "react"
import classes from "./detail-card.module.css"

type Props = {
  title?: ReactNode
  /** Right side of the title row (buttons). */
  extra?: ReactNode
  /** Body without padding (a table that runs edge to edge). */
  flush?: boolean
  /** Stretch to the grid cell (side-by-side cards of equal height). */
  fill?: boolean
  children: ReactNode
}

/** Card of the supplier order detail canvases: title row over a thin rule, then the body. */
export function DetailCard({ title, extra, flush, fill, children }: Props) {
  return (
    <Box className={classes.card} data-fill={fill || undefined}>
      {(title || extra) && (
        <Group justify="space-between" align="center" wrap="nowrap" gap="sm" className={classes.head}>
          {title && <Text className={classes.title}>{title}</Text>}
          {extra}
        </Group>
      )}
      {flush ? children : <Box className={classes.body}>{children}</Box>}
    </Box>
  )
}

/** Label over value, plain weight (customer / receiving fields). */
export function DetailField({ label, children, mono }: { label: ReactNode; children: ReactNode; mono?: boolean }) {
  return (
    <Box>
      <Text className={classes.label}>{label}</Text>
      <Text component="div" className={mono ? `${classes.value} ${classes.mono}` : classes.value}>
        {children === undefined || children === null || children === "" ? "-" : children}
      </Text>
    </Box>
  )
}

/** Label left, value right (summary rows in the side cards). */
export function DetailRow({ label, children, mono }: { label: ReactNode; children: ReactNode; mono?: boolean }) {
  return (
    <Group justify="space-between" wrap="nowrap" gap="md" align="flex-start">
      <Text className={classes.label}>{label}</Text>
      <Text component="div" ta="right" className={mono ? `${classes.value} ${classes.mono}` : classes.value}>
        {children === undefined || children === null || children === "" ? "-" : children}
      </Text>
    </Group>
  )
}
